import { nl } from 'date-fns/locale';
import { LocaleDefinition } from '../localeDefinition';
import messages from './nl.json';

const definition: LocaleDefinition = {
  code: 'nl-NL',
  messages,
  dateFnsLocale: nl,
};

export default definition;
